<template>
  <div class="header" :id="!head ? 'headerActive' : ''">
    <div class="titleHead" v-if='head'>
      <h3 class="animated bounceInLeft">{{title}}</h3>
      <h3 class="animated bounceInRight">{{titleEn}}</h3>
    </div>
    <div class="titleHead titleHead1" v-else>
      <div class="animated bounceInLeft">{{title}}</div>
      <div class="animated bounceInRight">{{titleEn}}</div>
    </div>
    <div>
    <img :class="{Luminescence:homePage}" :src="src" alt />
    </div>
    <div class="navLogo" v-if="!head">
      <img :src='require("../assets/聚跃倾斜logo.png")' alt="">
    </div>
    <div class="titleList mobile">
    </div>
  </div>
</template>
<script>
import {getNavTitle } from '../api/allApiRequest.js'
export default {
  name: "headNav",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    titleEn: {
      type: String,
      default: ""
    },
    src: {
      type: String,
      default: ''
    },
    head:{
      type: Boolean,
      default: true
    },
    homePage:{
      type: Boolean,
      default : false
    }
  },
  mounted() {
  },
  methods: {}
};
</script>
<style scoped>
.header,
.header img {
  width: 100%;
  height: 4.4rem;
}
#headerActive,#headerActive img{
  width: 100%;
  height: 100%;
}
.header {
  position: relative;
}
.titleHead {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  font-weight: bold;
  text-shadow: 0px 5px 5px rgba(50,51,51,0.98);
}
.titleHead1{
   top: 87%;
}
.titleHead h3 {
  font-weight: 600;
  font-size: 30px;
  color: #fff;
}
.titleHead h3:nth-child(2) {
  font-size: 24px;
}
.titleHead1 div {
  font-weight: 600;
  font-size: 30px;
  color: #fff;
}
.titleHead1 div:nth-child(2) {
  margin-top:20px;
  font-size: 24px;
}
.title {
  font-size: 20px;
  color: #fff;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  height: 60px;
  line-height: 60px;
}
.titleList {
  position: absolute;
  width: 100%;
  top: 100%;
  margin-top: -61px;
  background-color: rgba(7, 7, 7, 0.8);
  z-index: 100;
}
.mobile {
  display: block;
}
.navLogo{
   position: absolute;
   z-index: 10000;
   width: 15%;
   top: 21.5%;
   left: 45.5%;
   /* animation: navlogo 10s infinite linear; */
   overflow: hidden;
   /* 不循环播放停留在最后一侦 */
   animation: navlogo 10s;
   animation-fill-mode: forwards; 
}
.navLogo>img{
   height: 100%;
}
@keyframes navlogo {
   0%{
     transform: scale(1); 
   }
   50%{
     transform: scale(1.2); 
   }
   100%{
     transform: scale(1); 
   }
}
@media screen and (max-width: 750px) {
  .header,
  .header img {
    height:   155px;
  }
  .titleHead h3 {
    font-size: 18px !important;
  }
  .mobile {
    display: none;
  }
  .navLogo{
   position: absolute;
   z-index: 10000;
   /* width: 20%; */
   height: 40px;
   top: 25%;
   left: 47%;
   animation: navlogo 10s infinite linear;
   overflow: hidden;
 }
 .navLogo>img{
   width: 100%;
   height: 40px;
 }
 }
</style>